<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">抄襲檢查工具</h1>
                        <h2>涵蓋全球最大學術資料庫，精確檢測與現有文獻的相似性</h2>
                        <p>深受頂尖大學與知名出版社信賴，Trinka 抄襲檢查不僅比對網頁內容，還能跨越 1.9 億篇付費學術文章，全面檢測您的內容是否有抄襲疑慮。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">立即開始檢查</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="/assets/images/plagiarism-check/plagiarism-check.jpg">
                            <source src="/assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <button class="icon-pause button-play" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-sm trinka-banner stats-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="media line-r">
                    <div class="media-left">
                        <h3 class="text-white">1億9千萬＋</h3>
                    </div>
                    <div class="media-body">
                        <p class="text-white mb-0">付費學術文章與論文</p>
                    </div>
                    <span>主要特色</span>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="media line-r">
                    <div class="media-left">
                        <h3 class="text-white">990億＋</h3>
                    </div>
                    <div class="media-body">
                        <p class="text-white mb-0">現有及歷史網頁資料</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="media line-r">
                    <div class="media-left">
                        <h3 class="text-white">2億＋</h3>
                    </div>
                    <div class="media-body">
                        <p class="text-white mb-0">開放取用學術文章</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                <div class="media">
                    <div class="media-left">
                        <h3 class="text-white">每日動態更新 1.02 億</h3>
                    </div>
                    <div class="media-body">
                        <p class="text-white mb-0">筆網頁資料</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="plagCheckKeyFeatures section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#freeScore">
                                <span>免費點數</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#standardPlagiarism">
                                <span>標準抄襲檢查</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="pill" href="#advancedPlagiarism">
                                <span>高級抄襲檢查</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active">
                        <div class="pc-para">
                            <!-- <span>Checks Against Internet Sources & Detects AI-generated Content</span> -->
                            <span>檢查網路資料來源並偵測 AI 生成內容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="/assets/images/plagiarism-check/text-block.svg" width="32" height="32" alt="text icon" /></span>
                                                    前 3 大匹配來源
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>列出前3個匹配的來源以及匹配百分比。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="/assets/images/plagiarism-check/sources.svg" width="32" height="32" alt="similar sources" /></span>
                                                    顯示整體相似度分數
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>文件將根據檢測出的抄襲問題，給予整體內容相似度評分。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="/assets/images/plagiarism-check/global.svg" width="32" height="32" alt="global" /></span>
                                                    網路來源相似度分數
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>顯示文件與各網路來源的個別相似度分數。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/matching-scroe.svg" width="520" height="263" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/overall-score.svg" width="423" height="394" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/overall-paid.svg" width="420" height="363" alt="internet sources" class="flags" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <!-- <span>Checks Against Internet Sources & Detects AI-generated Content</span> -->
                            <span>檢查網路資料來源並偵測 AI 生成內容</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="/assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    AI-generated Content Detector
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Detects content generated by Large Language Models such as ChatGPT.</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="/assets/images/plagiarism-check/sources.svg" width="32" height="32" alt="icon" /></span>
                                                    列出主要相似來源
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>報告會列出最相似的來源，並清楚標示出它們與您文件內容的匹配百分比。這能讓您快速找出最主要的重複來源。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="/assets/images/plagiarism-check/text-block.svg" width="32" height="32" alt="text icon" /></span>
                                                    標示相似文字
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>針對每一個相似來源，報告中會清楚標示與來源相符的文字段落。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="/assets/images/plagiarism-check/flag-2.svg" width="32" height="32" alt="flag icon" /></span>
                                                    偵測隱藏內容
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>偵測並標記文件中的隱藏文字及可疑字元。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="/assets/images/plagiarism-check/share_1.svg" width="32" height="32" alt="icon" /></span>
                                                    排除選擇區塊
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>可以彈性選擇將文件中的特定段落或章節排除在檢查範圍外。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <!-- <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="/assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="/assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div> -->
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/sources.png" width="852" height="1048" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/highlight.png" width="928" height="988" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/flags-hidden.png" width="852" height="1074" alt="paid publications" class="flags" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/eclude-choosen.png" width="928" height="850" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>涵蓋付費文章與網路資源比對<br/>
                                學術論文推薦的抄襲檢查工具</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="/assets/images/plagiarism-check/sources.svg" width="32" height="32" alt="icon" /></span>
                                                    列出主要相似來源
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>報告會列出最相似的來源，並清楚標示出它們與您文件內容的匹配百分比。這能讓您快速找出最主要的重複來源。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="/assets/images/plagiarism-check/text-block.svg" width="32" height="32" alt="text icon" /></span>
                                                    標示相似文字
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>針對每一個相似來源，報告中會清楚標示與來源相符的文字段落。</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="/assets/images/plagiarism-check/flag-2.svg" width="32" height="32" alt="flags icon" /></span>
                                                    偵測隱藏內容
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>偵測並標記文件中的隱藏文字及可疑字元。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="/assets/images/plagiarism-check/export.svg" width="32" height="32" alt="exclude icon" /></span>
                                                    排除選擇區塊
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>可以彈性選擇將文件中的特定段落或章節排除在檢查範圍外。</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="/assets/images/plagiarism-check/share_1.svg" width="32" height="32" alt="share icon" /></span>
                                                    多種分享選項
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>提供多元報告分享方式，方便與團隊或指導教授交流。</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/sources.png" width="852" height="1048" alt="sources" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/highlight.png" width="928" height="988" alt="highlight" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/flags-hidden.png" width="852" height="1074" alt="flags" class="flags" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/eclude-choosen.png" width="928" height="850" alt="exclude" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="/assets/images/plagiarism-check/share.png" width="928" height="920" alt="exclude sections" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="writing_need_sections section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>找到最適合您的抄襲檢查方案</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>來源/特點</th>
                                    <th>免費點數</th>
                                    <th>標準抄襲檢查</th>
                                    <th>高級抄襲檢查</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1億9千萬＋付費學術文章與論文</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>990億＋現有及歷史網頁資料</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2億＋開放取用學術文章</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>每日動態更新 1.02 億筆網頁資料</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>互動式報告，支援 PDF 下載</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinka 高級 Plus 可無限次使用標準抄襲檢查</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a [routerLink]="['/pricing']" routerLinkActive="active" class="white-btn">
                        <span>了解更多</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="#000"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="#000"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd standOut bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka 抄襲檢查的獨特之處</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Trinka & Enago Reports</th>
                                    <th class="grammarly">Grammarly</th>
                                    <th class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>
                                            高級抄襲檢查
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            標準超級檢查
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            無限次使用相似度檢查報告
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip-content custom-tooltip-transform">
                                                    僅限高級 Plus 方案
                                                </span>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>20 pages/mo</td>
                                </tr>
                                <tr>
                                    <td>可下載 PDF 報告</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">使用Trinka每月獲得高達2個免費的iThenticate點數</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup_rg=TW" class="white-btn">
                        <span>開始使用</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="#000"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="#000"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="suitableForSection section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>Trinka 抄襲檢查工具的適用對象
                    </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M36.1056 8.34517L20.4134 3.06772C20.145 2.97743 19.8547 2.97743 19.5863 3.06772L3.89413 8.34517C3.63374 8.43275 3.40727 8.60077 3.2468 8.82542C3.08632 9.05008 2.99998 9.31999 3 9.59692V22.7906C3 23.1405 3.13777 23.4761 3.38301 23.7235C3.62825 23.9709 3.96086 24.1099 4.30768 24.1099C4.6545 24.1099 4.98711 23.9709 5.23235 23.7235C5.47759 23.4761 5.61536 23.1405 5.61536 22.7906V11.4275L11.106 13.273C9.6472 15.6508 9.18331 18.5156 9.81618 21.2382C10.4491 23.9608 12.1269 26.3187 14.4814 27.7942C11.5392 28.9586 8.99572 31.0646 7.13554 33.9441C7.0388 34.0892 6.9716 34.2522 6.93785 34.4237C6.90411 34.5952 6.90449 34.7718 6.93897 34.9431C6.97345 35.1145 7.04134 35.2772 7.1387 35.4219C7.23607 35.5665 7.36095 35.6902 7.50611 35.7857C7.65126 35.8812 7.81379 35.9467 7.98424 35.9783C8.15469 36.0099 8.32966 36.007 8.49899 35.9697C8.66831 35.9325 8.82862 35.8617 8.97057 35.7614C9.11253 35.6611 9.23332 35.5333 9.32591 35.3855C11.7893 31.5726 15.6796 29.3874 19.9999 29.3874C24.3201 29.3874 28.2105 31.5726 30.6738 35.3855C30.8656 35.6731 31.1619 35.873 31.4986 35.942C31.8353 36.011 32.1854 35.9435 32.4732 35.7541C32.7609 35.5647 32.9633 35.2687 33.0364 34.93C33.1096 34.5913 33.0477 34.2372 32.8642 33.9441C31.004 31.0646 28.4507 28.9586 25.5183 27.7942C27.8705 26.3188 29.5468 23.9624 30.1796 21.2418C30.8123 18.5211 30.3499 15.6584 28.8937 13.2812L36.1056 10.8569C36.366 10.7694 36.5926 10.6014 36.7531 10.3767C36.9136 10.1521 37 9.88212 37 9.60516C37 9.3282 36.9136 9.05827 36.7531 8.8336C36.5926 8.60894 36.366 8.44094 36.1056 8.35342V8.34517ZM27.8459 18.8325C27.8463 20.084 27.5525 21.3177 26.9888 22.4325C26.425 23.5473 25.6073 24.5113 24.6028 25.2455C23.5982 25.9797 22.4355 26.4632 21.2099 26.6562C19.9843 26.8492 18.7308 26.7463 17.5523 26.3559C16.3738 25.9655 15.3038 25.2987 14.4301 24.4103C13.5564 23.5219 12.904 22.4371 12.5263 21.245C12.1486 20.0529 12.0565 18.7875 12.2574 17.5525C12.4583 16.3175 12.9466 15.1482 13.6821 14.1405L19.5863 16.1195C19.8547 16.2098 20.145 16.2098 20.4134 16.1195L26.3176 14.1405C27.3111 15.4994 27.8467 17.1438 27.8459 18.8325Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>學生</h4>
                        <p>Trinka 幫助學生確認作品的原創性與正確引用，大幅降低無意抄襲的風險，並協助學習正確的引用方式，維護學術寫作標準。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M27.4833 3.33331H13.5167C7.45001 3.33331 3.83334 6.94998 3.83334 13.0166V26.9833C3.83334 31.6666 5.98334 34.8833 9.76668 36.1C10.8667 36.4833 12.1333 36.6666 13.5167 36.6666H27.4833C28.8667 36.6666 30.1333 36.4833 31.2333 36.1C35.0167 34.8833 37.1667 31.6666 37.1667 26.9833V13.0166C37.1667 6.94998 33.55 3.33331 27.4833 3.33331ZM34.6667 26.9833C34.6667 30.55 33.2667 32.8 30.45 33.7333C28.8333 30.55 25 28.2833 20.5 28.2833C16 28.2833 12.1833 30.5333 10.55 33.7333H10.5333C7.75001 32.8333 6.33334 30.5666 6.33334 27V13.0166C6.33334 8.31665 8.81668 5.83331 13.5167 5.83331H27.4833C32.1833 5.83331 34.6667 8.31665 34.6667 13.0166V26.9833Z" fill="#763393"/>
                            <path d="M20.5 13.3333C17.2 13.3333 14.5334 16 14.5334 19.3C14.5334 22.6 17.2 25.2833 20.5 25.2833C23.8 25.2833 26.4667 22.6 26.4667 19.3C26.4667 16 23.8 13.3333 20.5 13.3333Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>作者與研究人員</h4>
                        <p>作者及研究人員可利用 Trinka 掃描手稿，檢測潛在抄襲，確保作品獨特性，維護個人學術聲譽，是維持研究文件完整性的關鍵步驟。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M28.05 26.0667C29.1667 25.3333 30.6333 26.1333 30.6333 27.4667V29.6167C30.6333 31.7333 28.9833 34 27 34.6667L21.6833 36.4333C20.75 36.75 19.2333 36.75 18.3167 36.4333L13 34.6667C11 34 9.36667 31.7333 9.36667 29.6167V27.45C9.36667 26.1333 10.8333 25.3333 11.9333 26.05L15.3667 28.2833C16.6833 29.1667 18.35 29.6 20.0167 29.6C21.6833 29.6 23.35 29.1667 24.6667 28.2833L28.05 26.0667Z" fill="#763393"/>
                            <path d="M33.3 10.7667L23.3167 4.21672C21.5167 3.03339 18.55 3.03339 16.75 4.21672L6.71667 10.7667C3.5 12.8501 3.5 17.5667 6.71667 19.6667L9.38334 21.4001L16.75 26.2001C18.55 27.3834 21.5167 27.3834 23.3167 26.2001L30.6333 21.4001L32.9167 19.9001V25.0001C32.9167 25.6834 33.4833 26.2501 34.1667 26.2501C34.85 26.2501 35.4167 25.6834 35.4167 25.0001V16.8001C36.0833 14.6501 35.4 12.1501 33.3 10.7667Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>教師</h4>
                        <p>教師能利用 Trinka 檢查學生繳交的作業是否抄襲，促進學術誠信文化，同時作為教學工具，強調原創性的重要性。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M35.5 36.6666H5.5C4.81667 36.6666 4.25 36.1 4.25 35.4166C4.25 34.7333 4.81667 34.1666 5.5 34.1666H35.5C36.1833 34.1666 36.75 34.7333 36.75 35.4166C36.75 36.1 36.1833 36.6666 35.5 36.6666Z" fill="#763393"/>
                            <path d="M32.2 5.79998C28.9667 2.56664 25.8 2.48331 22.4833 5.79998L20.4667 7.81664C20.3 7.98331 20.2333 8.24998 20.3 8.48331C21.5667 12.9 25.1 16.4333 29.5167 17.7C29.5833 17.7166 29.65 17.7333 29.7167 17.7333C29.9 17.7333 30.0667 17.6666 30.2 17.5333L32.2 15.5166C33.85 13.8833 34.65 12.3 34.65 10.7C34.6667 9.04998 33.8667 7.44998 32.2 5.79998Z" fill="#763393"/>
                            <path d="M26.5167 19.2167C26.0333 18.9834 25.5667 18.75 25.1167 18.4834C24.75 18.2667 24.4 18.0334 24.05 17.7834C23.7667 17.6 23.4333 17.3334 23.1167 17.0667C23.0833 17.05 22.9667 16.95 22.8333 16.8167C22.2833 16.35 21.6667 15.75 21.1167 15.0834C21.0667 15.05 20.9833 14.9334 20.8667 14.7834C20.7 14.5834 20.4167 14.25 20.1667 13.8667C19.9667 13.6167 19.7333 13.25 19.5167 12.8834C19.25 12.4334 19.0167 11.9834 18.7833 11.5167C18.6716 11.2773 18.5713 11.0417 18.4789 10.8117C18.3429 10.4735 17.9062 10.3771 17.6485 10.6349L7.73333 20.55C7.51666 20.7667 7.31666 21.1834 7.26666 21.4667L6.36666 27.85C6.19999 28.9834 6.51666 30.05 7.21666 30.7667C7.81666 31.35 8.64999 31.6667 9.54999 31.6667C9.74999 31.6667 9.94999 31.65 10.15 31.6167L16.55 30.7167C16.85 30.6667 17.2667 30.4667 17.4667 30.25L27.3746 20.3421C27.6342 20.0825 27.5355 19.6393 27.1952 19.5017C26.9754 19.4129 26.7516 19.3185 26.5167 19.2167Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>編輯</h4>
                        <p>編輯可依賴 Trinka 驗證投稿文章的原創性，確保發表內容不含抄襲，維護出版品的公信力與信賴度。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">      
                        <svg fill="#763393" width="40px" height="40px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"></path></g></svg>
                    </div>
                    <div class="media-body">
                        <h4>教育機構</h4>
                        <p>教育機構可使用 Trinka 確保學生與教師發表的作品原創無虞，有效維護學術誠信，防止無意抄襲，並提升研究成果品質，強化機構聲譽。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">                   
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34.1667 16.9833H29.35C25.4 16.9833 22.1834 13.7666 22.1834 9.81659V4.99992C22.1834 4.08325 21.4334 3.33325 20.5167 3.33325H13.45C8.31669 3.33325 4.16669 6.66659 4.16669 12.6166V27.3833C4.16669 33.3333 8.31669 36.6666 13.45 36.6666H26.55C31.6834 36.6666 35.8334 33.3333 35.8334 27.3833V18.6499C35.8334 17.7333 35.0834 16.9833 34.1667 16.9833ZM19.2167 22.5499C18.9667 22.7999 18.65 22.9166 18.3334 22.9166C18.0167 22.9166 17.7 22.7999 17.45 22.5499L16.25 21.3499V28.3333C16.25 29.0166 15.6834 29.5833 15 29.5833C14.3167 29.5833 13.75 29.0166 13.75 28.3333V21.3499L12.55 22.5499C12.0667 23.0333 11.2667 23.0333 10.7834 22.5499C10.3 22.0666 10.3 21.2666 10.7834 20.7833L14.1167 17.4499C14.2334 17.3499 14.35 17.2666 14.4834 17.1999C14.5167 17.1833 14.5667 17.1666 14.6 17.1499C14.7 17.1166 14.8 17.0999 14.9167 17.0833C14.9667 17.0833 15 17.0833 15.05 17.0833C15.1834 17.0833 15.3167 17.1166 15.45 17.1666C15.4667 17.1666 15.4667 17.1666 15.4834 17.1666C15.6167 17.2166 15.75 17.3166 15.85 17.4166C15.8667 17.4333 15.8834 17.4333 15.8834 17.4499L19.2167 20.7833C19.7 21.2666 19.7 22.0666 19.2167 22.5499Z" fill="#763393"/>
                            <path d="M29.05 14.6834C30.6333 14.7001 32.8333 14.7001 34.7167 14.7001C35.6667 14.7001 36.1667 13.5834 35.5 12.9167C33.1 10.5001 28.8 6.15007 26.3333 3.6834C25.65 3.00007 24.4667 3.46674 24.4667 4.41674V10.2334C24.4667 12.6667 26.5333 14.6834 29.05 14.6834Z" fill="#763393"/>
                        </svg>    
                    </div>
                    <div class="media-body">
                        <h4>出版社</h4>
                        <p>出版社透過 Trinka 審核出版文本，確保內容原創並符合法律版權規範，避免法律風險，保護作者與出版社的專業形象。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>涵蓋1,700 多個付費科學期刊</h3>
                    <p>
                        採用最精準的文本相似度檢測演算法，幫助您驗證內容是否抄襲，維護作品的完整性與公信力。您的文章將與 Wiley、Springer Nature、Taylor & Francis、Sage 及其他多家頂尖出版社的出版品進行比對。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/features/plagiarism-check/plagiarism-check-map.webp" width="1184" height="775" alt="global publications" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>使用Trinka的抄襲檢查獲得高品質的評估</h3>
                    <p>市面上抄襲檢查工具眾多，選擇不易。我們針對多款熱門工具進行分析比較，結果顯示 Trinka 在準確度與可靠性方面表現優異。</p>
                    <p>Trinka 在一篇明顯抄襲的論文測試中，超越多數競品。我們依據準確率、資料庫規模、易用性、成本及安全性等六大指標，評比出 Trinka 提供業界領先的檢測與專業支持，同時嚴格保護您的資料隱私。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/plagiarism-check/plagiarism-check-graph.jpg" width="572" height="472" alt="trinka plagiarism check against competitors" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>為什麼選擇 Trinka 抄襲檢查？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-none">
                            <img src="/assets/images/languageScore_icon.svg" width="40" height="40" alt="free plagiarism check"/>
                            <h3>每月免費提供抄襲檢查點數</h3>
                            <p>在產生完整報告前，先免費檢查文件是否存在抄襲風險，涵蓋網路、開放取用與付費出版資料。</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards">
                            <img src="/assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="standard plagiarism check"/>
                            <h3>標準抄襲檢查無限次使用</h3>
                            <p>不限次數使用標準抄襲檢查，針對網路與開放取用文獻進行比對。</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <img src="/assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="superior detection technology"/>
                            <h3>頂尖偵測技術</h3>
                            <p>提供依語言類別分類的詳細修改表，快速掌握文本中需改進的部分。</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="list-wrapper-content-2 list-style-cards bt-1">
                            <img src="/assets/images/TypeOrImportFile_icon.png" width="32" height="40" style="min-width: 32px;max-width: 32px;" alt="upload files"/>
                            <h3>支援上傳 MS Word <br/>與 PDF 檔案</h3>
                            <p>Trinka 可檢查 MS Word (.doc/.docx) 與 PDF 格式檔案，使用彈性更大。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <app-credits-info
        [title]="'抄襲檢查使用點數'"
        [description]="'標準抄襲檢查需要使用 12 個點數，而高級抄襲檢查需要使用 18 個點數。您可以使用免費點數並根據需要時再靈活加購。'"
        [subText]="'點數就像代幣一樣，可以讓您靈活使用多項 Trinka 功能。<br/> 高級用戶每月將獲得 10 個免費點數，基本用戶每月獲得 4 個免費點數。瞭解更多資訊，<a href=\'/features/credits\' class=\'text-link\'>請點擊此處</a>。<br/>此外 Trinka 高級用戶每月可獲得 2次免費的抄襲檢查，並享受高達 6 折的點數包購買折扣。'"
    ></app-credits-info>
</section>

<section class="section-pd" style="background-color: #f5f5f5;">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title text-center">
                    <h2>如何使用</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-12">
                <div class="col-lg-12">
                    <div class="allPlans-wrapper">
                        <div class="plan-content plan-simple">
                            <div class="plan-header"></div>
                            <ul>
                                <li>免費點數 </li>
                                <li>標準抄襲檢查報告</li>
                                <li>高級抄襲檢查報告</li>
                                <li>每月可獲取點數</li>
                                <li>批量購買點數價格</li>
                            </ul>
                        </div>
                        <div class="plan-content plan-basic">
                            <div class="plan-header">
                                基本
                            </div>
                            <ul>
                                <li><span><b>每月 </b> 1 個點數 </span></li>
                                <li><span>每次需要 <b>12 個點數 </b></span></li>
                                <li><span>每次需要 <b>18 個點數</b></span></li>
                                <li><span><b>每月 </b> 4 個點數</span></li>
                                <li><span>每點數僅需 3美元<br/> （40個點數）</span></li>
                            </ul>
                        </div>
                        <div class="plan-content plan-premium">
                            <div class="plan-header">
                                高級
                            </div>
                            <ul>
                                <li><span><b>每月</b> 2 個點數</span></li>
                                <li><span>每次需要 <b>12 個點數</b></span></li>
                                <li><span>每次需要 <b>18 個點數</b></span></li>
                                <li><span><b>每月</b> 10 個點數</span></li>
                                <li><span>每點數僅需1.8美元<br/> （40個點數）</span></li>
                            </ul>
                        </div>
                        <div class="plan-content plan-recommended">
                            <div class="plan-header">
                                高級 Plus
                                <span>Recommended</span>
                            </div>
                            <ul>
                                <li><span><b>每月 </b> 2 個點數</span></li>
                                <li><span><b>每月120頁 </b>  （1頁=250字）</span></li>
                                <li><span>每次需要 <b>18 個點數</b></span></li>
                                <li><span><b>每月 </b>10 個點數</span></li>
                                <li><span>每點數僅需1.8美元<br/> （40個點數）</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-security-section></app-security-section>

<section class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">杜絕抄襲風險，自信交件無壓力</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 抄襲檢查怎麼使用?</a>
                                </div>
    
                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>非常簡單！</h4>
                                        <ol>
                                            <li>登入您的 Trinka Cloud 帳號（還沒有免費帳號嗎？<a href="https://cloud.trinka.ai/signup_rg=TW" target="_blank">立即註冊！</a> )</li>
                                            <li>點選右側面板的「抄襲檢查」功能，進入檢查頁面</li>
                                            <li>上傳文件，選擇您想使用的檢查類型，也可以選取已儲存在 Trinka Drive 中的檔案</li>
                                            <li>幾分鐘內即可收到詳細檢查報告！</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Trinka 的抄襲檢查與其他工具有什麼不同？</a>
                                </div>
    
                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的抄襲檢查功能與其他工具最大的不同在於，它給你選擇的彈性，能讓你根據需求決定檢查範圍——你可以只檢查網路內容，或是同時涵蓋網路內容和付費出版物。</p>
                                        <p>Trinka 採用全球頂尖學術出版社信賴的高階檢測技術，準確度領先業界。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可免費使用 Trinka 抄襲檢查嗎?
                                    </a>
                                </div>
    
                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以在Trinka上免費獲得抄襲檢查分數!</p>
                                        <p>如果您有一個基本帳戶，您每個月可以得到1次免費的抄襲檢查。如果您有一個Trinka高級帳戶，您將每月獲得2次免費的抄襲檢查。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        抄襲檢查報告可以下載嗎？
                                    </a>
                                </div>
    
                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以！抄襲檢查報告會以 PDF 格式產出，可隨時下載保存。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        我的文件會被 Trinka 儲存嗎？
                                    </a>
                                </div>
    
                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 不會儲存您的文件，也不會將其加入任何資料庫中。</p>
                                        <p>報告生成後，僅會顯示於您的個人後台，不會被存放在其他地方。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        什麼是線上抄襲檢查工具？
                                    </a>
                                </div>
    
                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>線上抄襲檢查工具是一種基於網頁的應用程式，可幫助使用者檢測文本中的抄襲情形。</p>
                                        <p>透過先進演算法，它能與網路與出版資料庫中的內容比對，找出是否有重複或抄襲的段落。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        如何使用線上工具檢查是否有抄襲？
                                    </a>
                                </div>
    
                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以透過像 Trinka 這樣的線上抄襲檢查工具來快速檢測文章是否涉及抄襲。只需將文字貼上或上傳文件，系統便會自動與網路內容和付費出版資料庫中的大量文獻進行比對，偵測是否有重複或相似之處。</p>
                                        <p>檢查完成後，平台會提供一份詳細報告，清楚標示出與其他來源相符的段落與比對結果，協助您確認內容的原創性。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        我可以上傳哪些檔案格式到 Trinka 進行抄襲檢查？
                                    </a>
                                </div>
    
                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以上傳 MS Word（.doc / .docx）或 PDF 檔案至 Trinka 進行抄襲檢查，系統會自動比對內容並產出詳細報告。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>